module.exports = __webpack_public_path__ + "static/media/nodejs.e87d5cff.png";